import {Component, OnInit} from '@angular/core';
import {TableNumberService} from "../../core/http/table-number.service";
import {Router} from "@angular/router";
import {AuthService} from "../../core/auth/auth.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  loginCode?: string;

  constructor(private router: Router, public authService: AuthService) {}

  ngOnInit() {
  }

  login(): void {
    if (this.loginCode) {
      this.authService.loginWithCode(this.loginCode);
    }
  }
}
